import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RelatedCourse from './RelatedCourse';
import styles from './styles';
import messages from './messages';

function CoursesWidget({ widget }) {
  const { options, content } = widget;
  const { limit, source, campaign, medium, layout } = options;
  const recommends = content?.filter((r, index) => index < limit);

  if (!recommends.length) {
    return null;
  }

  const className = layout === 'unycos'
    ? 'widget related-courses-style-2 margin-bottom-big'
    : 'widget related-courses margin-bottom-big';

  return (
    <Fragment>
      <div id="course-related-widget" className={className}>
        {options['hide-title'] !== 'true' && !options['custom-title'] && (
          <FormattedMessage {...messages.relatedCourses} values={{ counter: recommends.length }}>
            {(label) => (
              <div className="section-title">
                <span className="label titles-color text-uppercase">
                  {label}
                </span>
              </div>
            )}
          </FormattedMessage>
        )}
        {options['hide-title'] !== 'true' && options['custom-title'] && (
          <div className="section-title">
            <span className="label titles-color text-uppercase">
              {options['custom-title']}
            </span>
          </div>
        )}
        <section
          id="latest-posts-widget"
          className="widget latest-posts-widget posts-style-9"
        >
          <div className="posts-row">
            {recommends.map((related) => (
              <RelatedCourse
                key={related._id}
                item={related}
                externalUrl={options['external-url']}
                source={source}
                campaign={campaign}
                medium={medium}
                buttonText={options['button-text']}
                layout={layout}
              />
            ))}
          </div>
        </section>
        <hr className="transparent-bg" />
      </div>
      <style jsx>{styles}</style>
    </Fragment>
  );
}

CoursesWidget.defaultProps = {
  widget: {
    options: {},
    content: [],
  },
};

CoursesWidget.propTypes = {
  widget: PropTypes.object,
};

export default CoursesWidget;
